import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-icon-context-email',
    templateUrl: './icon-context-email.component.html',
    styleUrl: '../icon-shared/icon-shared.scss'
})
export class IconContextEmailComponent {
    @Input() isActive: boolean = false;
}
